import React, { Component } from 'react';

class CardBet extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        const currentMonth = new Date(this.props.date).getUTCMonth() + 1;

        return (
            <div className="bg-indigo-50 py-3 px-4 rounded-lg ring-indigo-100 shadow">
                <div className="flex">
                    <svg width="24" height="24" className="text-indigo-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <p className="pl-2 font-medium text-indigo-600">{this.props.name}</p>
                </div>
                {this.props.date && <div className="flex mt-1 items-center">
                    <svg width="24" height="24" className="text-indigo-300" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <p className="pl-2 text-sm text-indigo-300">{`${new Date(this.props.date).getUTCDate()}/${currentMonth.toString().padStart(2, '0')}/${new Date(this.props.date).getUTCFullYear()}`}</p>
                </div>}
            </div>
        );
    }
}

export default CardBet
